var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualSeeker2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 74",
    style: {
      enableBackground: "new 0 0 110 74"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D61983;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,74H5.9c-3,0-5.4-2.4-5.4-5.4V5.7c0-3,2.4-5.4,5.4-5.4h98.2c3,0,5.4,2.4,5.4,5.4v62.9 C109.5,71.6,107.1,74,104.1,74z M8,3.6c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S9.1,3.6,8,3.6z M15.1,3.6c-1.1,0-2,0.9-2,2s0.9,2,2,2 c1.1,0,2-0.9,2-2S16.2,3.6,15.1,3.6z M22,3.6c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S23.2,3.6,22,3.6z M105.9,11.2H4.1v5.6h101.8 V11.2z M105.9,22.4H4.1v46.2c0,1,0.8,1.8,1.8,1.8h98.2c1,0,1.8-0.8,1.8-1.8V22.4z M87.2,68.2c0,0-2,0.8-2,0.8c0,0-2.7-7.5-2.7-7.5 l-3.9,3.9l0-17.3l0,0l11.2,13.3l-5.5-0.5C84.2,60.8,87.1,68.2,87.2,68.2z M70.2,56.2c0,0-2,0.8-2,0.8c0,0-2.7-7.5-2.7-7.5l-3.9,3.9 l0-17.3l0,0l11.2,13.3l-5.5-0.5C67.2,48.8,70.1,56.2,70.2,56.2z M58.2,68.2c0,0-2,0.8-2,0.8c0,0-2.7-7.5-2.7-7.5l-3.9,3.9l0-17.3 l0,0l11.2,13.3l-5.5-0.5C55.2,60.8,58.1,68.2,58.2,68.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualSeeker2);
export default __webpack_public_path__ + "static/media/manual-seeker-2.fbd2bed2bd9fc0fa11e97a77f7ec1219.svg";
export { ForwardRef as ReactComponent };